/**
 * Andre Garen - koleksiyon izgarasi ekleri (Tur 23 EK10 \u00a73.3). Yalniz koleksiyon sayfasinda yuklenir.
 *  S012 Editoryal gorunum: arac cubugundaki anahtar ([data-ag-gorunum], aria-pressed) izgara ile tek sutun buyuk fotograf
 *       arasinda gecer; secim bu cihazda (localStorage ag:gorunum). Tek sutunda kart 4:5; kart fotograf rayi kaydirilinca
 *       ikinci fotograf gelir (mevcut kart davranisi). Gorsel kaynagi 700 px fiziksel genisligi gecmez (sizes = 700/dpr).
 *  S010 Kaldigin yer: urune dokununca son kart ve konum sessionStorage'a (ag:kaldigin, sunucuya gitmez); urun sayfasindan
 *       geri gelince (geri tusu ya da urun sayfasindan gelis) sayfa o karta kayar, kart 1,2 sn ince altin cerceve ve
 *       "Son baktigin" etiketiyle isaretlenir, odak karta tasinir. Kart yoksa (satildi, suzgec degisti) en yakin karta
 *       donulur, cerceve cizilmez. Hareket azaltmada gecissiz.
 * Anahtarli: window.agOz('S012') / ('S010') (deneme modunda deneme ogeleri).
 */
(function () {
  'use strict';
  var oz = function (id) { return !!(window.agOz && window.agOz(id)); };
  var grid = document.querySelector('[data-ag-collection-grid]');
  if (!grid) return;
  var gor = function (e) { return !!e && e.getClientRects().length > 0; };

  /* ---------------- S012 editoryal gorunum ---------------- */
  var tg = document.querySelector('[data-ag-gorunum]');
  if (tg && oz('S012')) {
    var tek = false; try { tek = localStorage.getItem('ag:gorunum') === 'tek'; } catch (e) {}
    var uygula = function (v) {
      tek = v;
      grid.setAttribute('data-ag-gorunum', v ? 'tek' : 'izgara');
      [].forEach.call(tg.querySelectorAll('[data-ag-gorunum-sec]'), function (x) { x.setAttribute('aria-pressed', (x.getAttribute('data-ag-gorunum-sec') === 'tek') === v ? 'true' : 'false'); });
      var sz = Math.round(700 / (window.devicePixelRatio || 1)) + 'px';
      [].forEach.call(grid.querySelectorAll('.ag-card__img, .ag-card__railimg'), function (img) {
        if (!img.hasAttribute('data-ag-sizes')) img.setAttribute('data-ag-sizes', img.getAttribute('sizes') || '');
        img.setAttribute('sizes', v ? '(min-width: 1024px) 420px, ' + sz : img.getAttribute('data-ag-sizes'));
      });
    };
    uygula(tek);
    tg.addEventListener('click', function (e) {
      var d = e.target.closest('[data-ag-gorunum-sec]'); if (!d) return;
      uygula(d.getAttribute('data-ag-gorunum-sec') === 'tek'); try { localStorage.setItem('ag:gorunum', tek ? 'tek' : 'izgara'); } catch (x) {}
    });
  }

  /* Tur 23 EK10 Faz 2 S004 Etek boyu (kisa hali): Uzun / Midi / Mini ciplerinde gercek sayi (izgaradaki kartlar, cip suzgeciyle
     ayni eslesme), boy cizgisi (diz ustu / baldir / bilek, sus); 0 ise kesik cizgi, aria-disabled, dokunulamaz; secili boya ikinci
     dokunus secimi kaldirir (Tumu). Ekran okuyucu: "Uzun, 7 parca". */
  (function boy() {
    if (!(window.agOz && window.agOz('S004'))) return;
    var row = document.querySelector('[data-ag-chiprow]'), grid = document.querySelector('[data-ag-collection-grid]');
    if (!row || !grid || !row.querySelector('[data-ag-chip="uzun"]')) return;
    var kartlar = [].slice.call(grid.querySelectorAll('.ag-card')).filter(function (c) { return !c.hasAttribute('data-ag-size-out'); });
    var etiket = kartlar.map(function (c) { var t = (c.getAttribute('data-ag-tags') || '').toLocaleLowerCase('tr').split('|'); return '|' + t.join('|') + '|' + t.join(' ').split(/\s+/).join('|') + '|'; });
    var tumu = row.querySelector('[data-ag-chip=""]');
    ['mini', 'midi', 'uzun'].forEach(function (v) {
      var ch = row.querySelector('[data-ag-chip="' + v + '"]'); if (!ch) return;
      var es = (ch.getAttribute('data-ag-chip-esler') || v).toLocaleLowerCase('tr').split('|');
      var n = etiket.filter(function (t) { return es.some(function (e) { return t.indexOf('|' + e + '|') > -1; }); }).length;
      var ad = ch.textContent.trim();
      ch.classList.add('ag-fchip--boy', 'ag-fchip--boy-' + v); ch.setAttribute('data-ad', ad);
      ch.innerHTML = '<span class="ag-boy-cizgi" aria-hidden="true"></span>' + ad + ' <span class="ag-fchip__sayi">' + n + '</span>';
      ch.setAttribute('aria-label', ad + ', ' + n + ' par\u00e7a');
      if (!n) { ch.setAttribute('aria-disabled', 'true'); ch.classList.add('ag-fchip--bos'); }
    });
    row.addEventListener('click', function (e) {
      var b = e.target.closest('.ag-fchip--boy'); if (!b) return;
      if (b.getAttribute('aria-disabled') === 'true') { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (b.getAttribute('aria-pressed') === 'true' && tumu) { e.preventDefault(); e.stopImmediatePropagation(); tumu.click(); }
    }, true);
  })();

  /* ---------------- S010 kaldigin yer ---------------- */
  if (!oz('S010')) return;
  var KEY = 'ag:kaldigin';
  var kartlar = function () { return [].filter.call(grid.querySelectorAll('.ag-card'), gor); };
  var yol = function (a) { try { return new URL(a.href, location.href).pathname; } catch (e) { return ''; } };
  /* window yakalama: ag-cardnav.js kart tiklamasini document yakalamada durdurur (stopPropagation) */
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ag-card a.ag-card__link'); if (!a || !grid.contains(a)) return;
    var k = kartlar(), i = k.indexOf(a.closest('.ag-card'));
    try { sessionStorage.setItem(KEY, JSON.stringify({ sayfa: location.pathname + location.search, url: yol(a), i: i, t: Date.now() })); } catch (x) {}
  }, true);
  function geri() {
    var s = null; try { s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s || s.sayfa !== location.pathname + location.search || Date.now() - s.t > 18e5) return;
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!((nav && nav.type === 'back_forward') || /\/products\//.test(document.referrer) || geri.bf)) return;
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    var k = kartlar(); if (!k.length) return;
    var kart = k.filter(function (c) { var a = c.querySelector('a.ag-card__link'); return a && yol(a) === s.url; })[0];
    var tam = !!kart;
    if (!kart) kart = k[Math.max(0, Math.min(k.length - 1, s.i || 0))];
    kart.scrollIntoView({ block: 'center', behavior: 'auto' });
    var a = kart.querySelector('a.ag-card__link');
    /* programli odak: dokunmatikte halka cizilmez (altin cerceve yeri gosterir); klavyeyle sonraki odakta normal halka */
    if (a) { a.classList.add('ag-odak-sessiz'); a.addEventListener('blur', function () { a.classList.remove('ag-odak-sessiz'); }, { once: true }); try { a.focus({ preventScroll: true }); } catch (e) { a.focus(); } }
    if (!tam) return;
    var m = kart.querySelector('.ag-card__media') || kart;
    var et = document.createElement('span'); et.className = 'ag-card__son'; et.textContent = 'Son bakt\u0131\u011f\u0131n';
    var cer = document.createElement('span'); cer.className = 'ag-card__cerceve'; cer.setAttribute('aria-hidden', 'true');
    m.appendChild(cer); m.appendChild(et); kart.classList.add('ag-card--son');
    if (a) a.setAttribute('aria-describedby', 'ag-son-bakilan');
    et.id = 'ag-son-bakilan';
    setTimeout(function () { kart.classList.add('ag-card--son-son'); }, 1200);
    setTimeout(function () { kart.classList.remove('ag-card--son', 'ag-card--son-son'); et.remove(); cer.remove(); if (a) a.removeAttribute('aria-describedby'); }, 1700);
  }
  /* Chrome yuklemeden sonra kaydirmayi geri yukler ve JS odagini temizler: yuklemeden sonra calis (Tur 9 dersi) */
  if (document.readyState === 'complete') setTimeout(geri, 60); else window.addEventListener('load', function () { setTimeout(geri, 60); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { geri.bf = true; geri(); } });

})();

/* Gezi C (Yigit 25 Ekim): kumas/doku secenekleri (Payetli, Saten, Tül, Straplez) filtre panelinde "Doku" başlığı altında.
   Aynı filtre mantığı (gizli cıp düğmeleri); satır satır seçilir, tekrar dokununca kalkar. */
(function () {
  'use strict';
  var row = document.querySelector('[data-ag-chiprow]'), form = document.getElementById('ag-filter-form');
  if (!row || !form) return;
  var AD = { saten: 'Saten', tul: 'Tül', payetli: 'Payetli' };
  var dugmeler = Object.keys(AD).map(function (k) { return row.querySelector('[data-ag-chip="' + k + '"]'); }).filter(Boolean);
  var g0 = form.querySelector('.ag-filter__group'); if (!dugmeler.length || !g0) return;
  var g = g0.cloneNode(true); g.classList.add('ag-filter__group--doku'); g.removeAttribute('data-open');
  var bas = g.querySelector('.ag-filter__grouphead'); bas.setAttribute('aria-expanded', 'false'); bas.firstElementChild.textContent = 'Doku';
  var govde = g.querySelector('.ag-filter__groupbody'); govde.innerHTML = '';
  dugmeler.forEach(function (d) {
    var k = d.getAttribute('data-ag-chip'), l = document.createElement('label'); l.className = 'ag-filter__opt';
    l.innerHTML = '<input type="checkbox" data-doku="' + k + '"><span>' + AD[k] + '</span>'; govde.appendChild(l);
  });
  g0.parentNode.insertBefore(g, g0);
  function esle() { dugmeler.forEach(function (d) { var i = govde.querySelector('[data-doku="' + d.getAttribute('data-ag-chip') + '"]'); if (i) i.checked = d.getAttribute('aria-pressed') === 'true'; }); }
  var oz = document.createElement('input'); oz.type = 'hidden'; oz.name = 'ozel'; try { oz.value = new URLSearchParams(location.search).get('ozel') || ''; } catch (e) { oz.value = ''; } oz.disabled = !oz.value; form.appendChild(oz);
  govde.addEventListener('change', function (e) {
    var i = e.target.closest('[data-doku]'); if (!i) return;
    var k = i.getAttribute('data-doku');
    [].forEach.call(govde.querySelectorAll('[data-doku]'), function (x) { if (x !== i) x.checked = false; });
    var tumu = row.querySelector('[data-ag-chip=""]');
    if (i.checked) { oz.value = k; oz.disabled = false; var d = row.querySelector('[data-ag-chip="' + k + '"]'); if (d && d.getAttribute('aria-pressed') !== 'true') d.click(); }
    else { oz.value = ''; oz.disabled = true; if (tumu) tumu.click(); }
    setTimeout(esle, 50);
  });
  row.addEventListener('click', function () { setTimeout(esle, 80); });
  esle();
})();

/* Acilis gecesi P0-7: "Sonuclari goster" dokunulunca dugme hemen "Yükleniyor…" olur ve kilitlenir (cift dokunma yok) */
(function () {
  'use strict';
  var form = document.getElementById('ag-filter-form'); if (!form) return;
  var b = form.querySelector('button[type="submit"]'); if (!b) return;
  var eski = b.textContent;
  form.addEventListener('submit', function () { b.textContent = 'Y\u00fckleniyor\u2026'; b.setAttribute('aria-busy', 'true'); setTimeout(function () { b.disabled = true; }, 0); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { b.textContent = eski; b.disabled = false; b.removeAttribute('aria-busy'); } });
})();
